module.exports = __webpack_public_path__ + "img/Japan.294c8518.png";